/**
 * Centralised reference list of common food allergens (UK/EU FIC 14).
 * Shared across allergen capture screens (RecipeV2, Procurement Products)
 * to avoid duplicating the same list in multiple places.
 */
export interface AllergenReference {
  id: number;
  code: string;
  name: string;
  iconUrl: string;
}

export const commonAllergens: AllergenReference[] = [
  { id: 1, code: 'CELERY', name: 'Celery', iconUrl: '' },
  { id: 2, code: 'GLUTEN', name: 'Cereals containing gluten', iconUrl: '' },
  { id: 3, code: 'CRUSTACEANS', name: 'Crustaceans', iconUrl: '' },
  { id: 4, code: 'EGGS', name: 'Eggs', iconUrl: '' },
  { id: 5, code: 'FISH', name: 'Fish', iconUrl: '' },
  { id: 6, code: 'LUPIN', name: 'Lupin', iconUrl: '' },
  { id: 7, code: 'MILK', name: 'Milk', iconUrl: '' },
  { id: 8, code: 'MOLLUSCS', name: 'Molluscs', iconUrl: '' },
  { id: 9, code: 'MUSTARD', name: 'Mustard', iconUrl: '' },
  { id: 10, code: 'NUTS', name: 'Tree nuts', iconUrl: '' },
  { id: 11, code: 'PEANUTS', name: 'Peanuts', iconUrl: '' },
  { id: 12, code: 'SESAME', name: 'Sesame seeds', iconUrl: '' },
  { id: 13, code: 'SOYBEANS', name: 'Soybeans', iconUrl: '' },
  { id: 14, code: 'SULPHITES', name: 'Sulphur dioxide / sulphites', iconUrl: '' },
];
